import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'
import COLORS from 'constants/colors'

import Title from 'components/base/Title'

export const FeaturedPost = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: ${LAYOUT.VERTICALSPACEMOBILE} 0;
  h3 {
    margin: 0 0 20px;
  }
  article {
    max-width: 600px;
    text-align: center;
    margin: auto;
    img {
      max-width: 100%;
      width: auto;
    }
    ${MEDIA.medium`
      text-align: left;
      margin: 0;
    `}
  }
  ${MEDIA.medium`
    flex-direction: row;
    margin: ${LAYOUT.VERTICALSPACE} auto};
  `}
`

export const FeaturedPostImgFrame = styled.div`
  border: 2px solid ${COLORS.BORDERS};
  padding: 20px;
  max-width: 600px;
  margin: auto;
  img {
    display: block;
    margin: auto;
  }
`

export const FeaturedPostImg = styled.div`
  margin-bottom: 20px;
  ${MEDIA.medium`
    margin-right: 40px;
    margin-bottom: 0px;
    max-width: 500px;
    width: 100%;
  `}
  img {
    width: 100%;
    max-width: 500px;
    ${MEDIA.medium`
      margin-bottom: 0px;
      width: 460px;
  `}
  }
`

export const FeaturedPostTitle = styled(Title)`
  a:link,
  a:visited,
  a {
    text-decoration: none;
  }
`

export const GridHeader = styled.div`
  border-bottom: 4px solid ${COLORS.BORDERS};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 1280px;
  margin: 0 auto 40px;
  padding-bottom: 20px;
  h2 {margin:0;}
`

export const GridHeaderFilter = styled.div`
  margin-top: 10px;
  > div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    select {
      min-width: 200px;
    }
    label {
      margin-right: 5px;
    }
    ${MEDIA.medium`
      max-width: 640px;
      width: 100%;
    `}
  }
  ${MEDIA.medium`
    margin-top: 0;
  `}
`
